import Text from '@cartwhl/ui/base/Text';

export default function SectionHeader({
  title,
  description,
  maxWidthTitle = '939px',
  maxWidthDescription = '848px',
}: {
  title: string;
  description?: string;
  maxWidthTitle?: string;
  maxWidthDescription?: string;
}) {
  return (
    <div className="mb-10 space-y-5 lg:mb-18">
      <Text
        as="h2"
        variant="web/display/xl"
        lg:variant="web/display/3xl"
        style={{ maxWidth: maxWidthTitle }}
      >
        {title}
      </Text>
      {description && (
        <Text
          as="p"
          variant="web/body/medium/md"
          lg:variant="web/body/medium/24"
          style={{ maxWidth: maxWidthDescription }}
        >
          {description}
        </Text>
      )}
    </div>
  );
}
